import { Middleware } from "redux";
import { State } from "../../store";
import { dispatchAlerts } from "../../api/responseConverters";
import { setErrors } from "./alertsActions";
import { UNKNOWN_ERROR } from "../../api/tryCatchRequest";

const alertsMiddleware: Middleware<any, State> = (store) => (next) => (
  action
) => {
  if (action.type.includes("fulfilled")) {
    const alerts = dispatchAlerts(action.payload);
    alerts && store.dispatch(alerts);
    if (action.payload?.isError) {
      return next({
        ...action,
        type: action.type.replace("fulfilled", "rejected"),
      });
    }
    return next({ ...action, payload: action.payload.result });
  }

  if (action.type.includes("rejected")) {
    store.dispatch(setErrors(action.payload?.errorTable ?? [UNKNOWN_ERROR]));
    return next({ ...action, payload: { isError: true } });
  }
  return next(action);
};

export default alertsMiddleware;
